module.exports = __webpack_public_path__ + "img/pills-office.5fdd2c11.png";